module.exports = __webpack_public_path__ + "img/compass.af5f1595.svg";